export * from './move-points.page'
export * from './move-points.reducer'
